const ENTRY_URL_STORAGE_KEY = 'landing_entry_url_v1';

// Rutas que NO deben guardarse como URL de entrada
const EXCLUDED_PATHS = ['/registros'];

const normalizeUrl = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  return value.trim();
};

const isExcludedPath = (url) => {
  if (!url) return true;
  
  try {
    const urlObj = new URL(url);
    return EXCLUDED_PATHS.some(path => urlObj.pathname.startsWith(path));
  } catch {
    return false;
  }
};

const readStoredEntryUrl = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  try {
    return normalizeUrl(window.sessionStorage.getItem(ENTRY_URL_STORAGE_KEY));
  } catch (error) {
    console.warn('No se pudo leer entryUrl de sessionStorage', error);
    return '';
  }
};

const writeStoredEntryUrl = (value) => {
  if (typeof window === 'undefined' || !value) {
    return;
  }

  try {
    window.sessionStorage.setItem(ENTRY_URL_STORAGE_KEY, value);
  } catch (error) {
    console.warn('No se pudo guardar entryUrl en sessionStorage', error);
  }
};

export const getCurrentPageUrl = () => {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }

  return normalizeUrl(window.location.href);
};

export const persistEntryUrl = () => {
  const storedEntryUrl = readStoredEntryUrl();
  if (storedEntryUrl) {
    return storedEntryUrl;
  }

  const currentUrl = getCurrentPageUrl();
  
  // No guardar URLs de rutas excluidas (ej: /registros)
  if (isExcludedPath(currentUrl)) {
    return '';
  }
  
  if (currentUrl) {
    writeStoredEntryUrl(currentUrl);
  }

  return currentUrl;
};

export const getLeadEntryUrl = () => readStoredEntryUrl() || persistEntryUrl();
